import mutations from './occupationHealthPartner.mutations'
import actions from './occupationHealthPartner.actions'
import getters from './occupationHealthPartner.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
